import { differenceInMilliseconds } from 'owa-datetime';
import CalendarSurfaceItemBase from './itemTemplates/CalendarSurfaceItem.base';
import ContinuationDate from './ContinuationDate';
import React from 'react';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import { BaseComponent } from 'office-ui-fabric-react/lib/Utilities';
import { ControlIcons } from 'owa-control-icons';
import { getAllDayStyles } from './itemTemplates/CalendarSurfaceItem.styles';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';
import {
    CalendarSurfaceItemContentProps,
    CalendarSurfaceItemProps,
} from './itemTemplates/CalendarSurfaceItem.types';
import {
    renderIconWrapperAllDayItem,
    renderCharmWrapperAllDayItem,
} from './CalendarSurfaceItemComponentRenderer';

let classNames = require('classnames');
let surfaceItemStyles = require('./CalendarAllDaySurfaceItem.scss');

@observer
export default class CalendarAllDaySurfaceItem extends BaseComponent<CalendarSurfaceItemProps, {}> {
    public render() {
        let { item, itemState } = this.props;
        let hideFBBar =
            item.FreeBusyType == 'Free' || item.IsCancelled || item.ResponseType == 'Decline';
        let isMultiDay =
            differenceInMilliseconds(item.End, item.Start) > TimeConstants.MillisecondsInOneDay;
        let hideBorder =
            hideFBBar &&
            !(isMultiDay || (itemState && (itemState.continuesLeft || itemState.continuesRight)));

        return (
            <CalendarSurfaceItemBase
                {...this.props}
                onRender={this.renderContent}
                styles={getAllDayStyles}
                hideFreeBusyBar={hideFBBar}
                hideBorder={hideBorder}
            />
        );
    }

    private renderContent = (contentProps: CalendarSurfaceItemContentProps) => {
        let { item, colorScheme, charmId, itemState } = contentProps;

        return (
            <>
                <div className={classNames(surfaceItemStyles.itemContent)}>
                    {itemState && itemState.continuesLeft && (
                        <div className={classNames(surfaceItemStyles.continuationWrapper)}>
                            <Icon
                                iconName={ControlIcons.ChevronLeft}
                                className={classNames(
                                    surfaceItemStyles.icon,
                                    surfaceItemStyles.continuation
                                )}
                            />
                            <ContinuationDate date={item.Start} />
                        </div>
                    )}
                    <h2 className={surfaceItemStyles.itemSubject}>
                        {renderCharmWrapperAllDayItem(item, colorScheme, charmId)}
                        <span>{item.Subject}</span>
                    </h2>
                </div>
                {renderIconWrapperAllDayItem(item, itemState)}
            </>
        );
    };
}
